import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import { useConnectionMode } from '../../hooks/useConnectionMode';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';
import { Text } from '../custom/text';
import { Card } from 'antd';
import { Flex } from '@react-css/flex';
import { Box } from '../custom/box';

export const MapServiceCharges = (props) => {
  const [, softwareName] = useConnectionMode();
  const [isLoading, accountsList] = useAccounts('serviceCharge');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Card type="inner"   title={
    <Text fontSize={"large"} fontWeight="bolder">Service charges</Text>
  }>
    <Text mr="3.25rem" size="small">
      {`Service charges can be mapped to an account in ${softwareName}.`}
    </Text>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="ServiceCharge">
          Select a service charges account
        </LabelRequired>
        <Autocomplete
          isLoadingOptions={isLoading}
          id="ServiceCharge"
          name="ServiceCharge"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter service change account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Card>;
};
